import { render, staticRenderFns } from "./faqs_group.vue?vue&type=template&id=6e7be532&scoped=true&"
import script from "./faqs_group.vue?vue&type=script&lang=js&"
export * from "./faqs_group.vue?vue&type=script&lang=js&"
import style0 from "./faqs_group.vue?vue&type=style&index=0&id=6e7be532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7be532",
  null
  
)

export default component.exports